<template>
  <div>
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="recodePage">
      <div
        class="main-content1 pc"
        style="padding-top: 100px; padding-bottom: 100px"
      >
        <div style="width: 100%; margin: 0 auto">
          <img src="../../assets/wuyan.png" alt="" style="width: 100%" />
        </div>
        <div class="flex-center" style="margin: 20px 0">
          <template 
            v-for="(item, index) of titleList">
          <div
            style="flex: 1; text-align: center"
            v-if="item.isContent === 1"
            :key="index"
          >
            <div
              :class="
                'select-bar ' +
                (type.name === item.main_title ? 'select-bg' : '')
              "
              @click="getPdf(item)"
            >
              {{ item.main_title }}
            </div>
          </div>
           </template>
        </div>
        <div
          style="
            min-height: 600px;
            width: 80%;
            margin: 0 auto;
            background: #fff;
            padding: 10px 30px;
          "
        >
          <div style="margin: 0 auto; width: 90%" v-loading="loading">
            <div v-html="detail.content"></div>
            <div style="border: 1px">
              <div class="flex-center">
                <div style="width: 100%; width: 35px">
                  <img src="../../assets/fx.png" alt="" style="width: 100%" />
                </div>
                <div
                  style="
                    font-size: 20px;
                    color: #333;
                    margin-left: 10px;
                    flex: 1;
                  "
                >
                  黄家圣幸病例分享
                </div>
              </div>
              <div
                class="flex-center typeClick showList"
                style="margin-top: 20px"
                v-for="(item, index) of recordList"
                :key="index"
              >
                <img :src="item.images || ''" alt="" style="width: 360px" />
                <div style="margin-left: 40px">
                  <div style="font-size: 22px; color: #333">
                    {{ item.title || "" }}
                  </div>
                  <div
                    style="
                      color: #666;
                      margin: 20px 0;
                      line-height: 26px;
                      -webkit-line-clamp: 4;
                    "
                    class="ellipsis"
                    v-html="item.abstract || ''"
                  ></div>
                  <el-button class="getMore" @click="go(item)">
                    了解更多
                  </el-button>
                </div>
              </div>
              <div
                class="bottomTip"
                v-if="
                  this.recordList[this.recordList.length - 1].next_item === null
                "
              >
                已加载最新
              </div>
              <div v-if="waiting" class="bottomTip" style="font-size: 30px">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-content1 mobile">
        <div class="big-title" style="margin-bottom: 30px">
            <div class="big-name">病历简介</div>
            <div class="big-eng">
              <span class="line-left"></span>
              <span class="txt">medical Records</span>
              <span class="line-right"></span>
            </div>
          </div>
        <div class="" style="margin: 0.2rem 0.13rem; position: relative;">
          <div
            style="float: left; width: 0.15rem; margin-top: 0.06rem"
            @click="last"
          >
            <img
              src="../../assets/mobile/left.png"
              alt=""
              style="width: 100%"
            />
          </div>
          <van-tabs
            style="width: calc(100% - 0.3rem); float: left"
            v-model="active"
            type="card"
            swipeable
            color="#f3f3f3"
            background="#f3f3f3"
            :swipe-threshold="3"
            @click="switchTab"
          >
            <van-tab
              v-for="(item, index) of titleList"
              :key="index"
              :title="item.main_title"
              :title-class="`${index === active ? 'select-bg' : 'select-bar'}`"
            >
            </van-tab>
          </van-tabs>

          <div
            style="float: left; width: 0.15rem; margin-top: 0.06rem"
            @click="next"
          >
            <img
              src="../../assets/mobile/right.png"
              alt=""
              style="width: 100%"
            />
          </div>
          <div class="clear"></div>
        </div>
        <div
          style="
            min-height: 300px;
            width: 100%;
            margin: 0 auto;
            background: #fff;
            border-top:5px solid #f3f3f3;
            padding-top:5px;
          "
          v-loading="loading"
        >
          <div style="margin: 0 auto; width: 100%">
            <div v-html="detail.content" style="border-bottom:5px solid #f3f3f3;"></div>
            <div
              style="padding: 0 0.1rem; width: calc(100% - 0.4rem); border: 1px"
            >
              <div
                class="list-tit flex-center"
              >
                <div style="font-size: 0.16rem; flex: 1">
                  <span style="font-weight: blod; color: #763a27; padding: 0 0.1rem"
                    >病历分享</span
                  >
                  <!-- <span class="list-eng">Hospital Information</span> -->
                </div>
              </div>
              <div
                class="typeClick showList"
                style="padding: 0.2rem 0; border-bottom: 1px solid #e6e6e6"
                v-for="(item, index) of recordList"
                :key="index"
                @click="go(item)"
              >
                <div style="margin-left: 0.05rem">
                  <div
                    style="
                      font-size: 0.16rem;
                      color: #333;
                      font-weight:bold;
                      -webkit-line-clamp: 1;
                    "
                    class="ellipsis"
                  >
                    {{ item.title || "" }}
                  </div>
                  <div class="x1"></div>
                  <div
                    style="
                      color: #666;
                      margin: 0.1rem 0;
                      line-height: 0.2rem;
                      font-size: 0.14rem;
                      -webkit-line-clamp: 4;
                    "
                    class="ellipsis"
                    v-html="item.abstract || ''"
                  ></div>
                  <div class="x2"></div>
                </div>
              </div>
              <div
                class="bottomTip"
                v-if="
                  this.recordList[this.recordList.length - 1].next_item === null
                "
              >
                已加载最新
              </div>
              <div v-if="waiting" class="bottomTip" style="font-size: 30px">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import {
  getmenudetail,
  medicallist,
  synopsisDetail,
  synopsislBymedicalId,
} from "@/api/common";
export default {
  name: "HelloWorld",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      type: {
        name: "",
        id: null,
      },
      active: 0,
      activeIndex: "medicalRecord",
      info: { carousel: "", Mcarousel: "" },
      detail: {},
      titleList: [],
      recordList: [],
      waiting: false,
      loading: true,
    };
  },
  mounted() {
    getmenudetail({ id: 7 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
    medicallist().then((res) => {
      var titleList = []
      res.data.forEach(item => {
        if(item.isContent === 1){
          titleList.push(item)
        }
      });
      this.titleList = titleList;
      if (this.$route.query.type) {
        this.active = this.$route.query.active;
        this.getPdf(this.titleList[this.active]);
        this.fx(this.titleList[this.active],1)
      } else {
        this.getPdf(res.data[0]);
        this.fx(this.titleList[this.active],0)
      }
    });
    window.addEventListener("scroll", this.getScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
  methods: {
    fx(row,type){
      var name = "东莞黄家圣幸中医医院"
      var title = row.main_title
      var icon = row.images_icon
      var url = "http://www.sensin.com.cn/medicalRecord"
      if(type === 1){
        url + `?type=${this.type.id}&active=${this.active}`
      }
      this.postMessage(
          name,
          title,
          url,
          icon
        );
    },
    getScroll() {
      if (this.waiting === false) {
        if (
          this.getScrollHeight() -
            this.getScrollTop() -
            this.getWindowHeight() <=
          200
        ) {
          console.log(
            this.getScrollHeight() -
              this.getScrollTop() -
              this.getWindowHeight()
          );
          if (this.recordList[this.recordList.length - 1].next_item !== null) {
            this.nextPage();
          }
        }
      }
    },
    // 获取滑动位置
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    //文档的总高度
    getScrollHeight() {
      var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
    //浏览器视口的高度
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },

    switchTab(name, title) {
      console.log(name, title);
      this.getPdf(this.titleList[name]);
      this.fx(this.titleList[name],1)
    },
    getPdf(item) {
      this.loading = true
      this.recordList = [];
      this.type.name = item.main_title;
      this.type.id = item.id;
      synopsislBymedicalId({ medical_id: this.type.id }).then((res) => {
        this.loading = false
        this.detail = res.data;
        this.recordList.push(res.data.synopsis);
      });
    },
    go(item) {
      var name = "medicalRecordDetail";
      this.$router.push({
        name,
        query: { type: this.type, id: item.id },
      });
    },
    nextPage() {
      this.waiting = true;
      synopsislBymedicalId({
        medical_id: this.type.id,
        id: this.recordList[this.recordList.length - 1].next_item.id,
      }).then((res) => {
        this.recordList.push(res.data.synopsis);
        this.waiting = false;
      });
    },
    last() {
      if (this.active !== 0) {
        this.active--;
        this.getPdf(this.titleList[this.active]);
        this.fx(this.titleList[this.active],1)
      }
    },
    next() {
      if (this.active !== this.titleList.length - 1) {
        this.active++;
        this.getPdf(this.titleList[this.active]);
        this.fx(this.titleList[this.active],1)
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.recodePage .getMore {
  margin-top: 24px;
  color: #439392;
  border: 1px solid #439392;
  background-color: #fff;
  font-size: 12px;
  border-radius: 0;
  padding: 0;
  width: 146px;
  height: 30px;
  line-height: 30px;
  transition: all 0.5s;
}
.recodePage .flex-center:hover .getMore {
  text-decoration: underline;
  margin-top: 24px;
  color: #439392;
  border: 1px solid #439392;
  background-color: #fff;
  font-size: 12px;
  border-radius: 0;
  padding: 0;
  width: 146px;
  height: 30px;
  line-height: 30px;
}
.bottomTip {
  text-align: center;
  color: #999;
  font-size: 15px;
  margin-top: 26px;
  animation: fade-in;
  animation-duration: 0.5s; /*动画持续时间*/
  -webkit-animation: fade-in 0.5s; /*针对webkit内核*/
}
.recodePage .pc .select-bg {
  background-image: url(../../assets/textBg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 80px;
  line-height: 80px;
  color: #e5e5e5;
}
.recodePage .pc .select-bar {
  width: 190px;
  margin: 0 auto;
  padding: 0 70px 0 0;
  font-size: 17px;
  cursor: pointer;
}
@media screen and (max-width: 750px) {
  .recodePage .mobile {
    padding-top: 0.2rem;
  }
  .recodePage .getMore {
    margin-top: 0.1rem;
    color: #439392;
    border: 1px solid #439392;
    background-color: #fff;
    font-size: 0.12rem;
    border-radius: 0;
    padding: 0;
    width: 1rem;
    height: 0.3rem;
    line-height: 0.3rem;
    transition: all 0.5s;
  }

  .recodePage .flex-center:hover .getMore {
    text-decoration: underline;
    margin-top: 0.1rem;
    color: #439392;
    border: 1px solid #439392;
    background-color: #fff;
    font-size: 0.12rem;
    border-radius: 0;
    padding: 0;
    width: 1rem;
    height: 0.3rem;
    line-height: 0.3rem;
  }
  .bottomTip {
    text-align: center;
    color: #999;
    font-size: 15px;
    margin-top: 26px;
    animation: fade-in;
    animation-duration: 0.5s; /*动画持续时间*/
    -webkit-animation: fade-in 0.5s; /*针对webkit内核*/
  }
  .x1 {
    margin-top:0.1rem;
    height: 18px;
    background: url(../../assets/mobile/bar8.png) no-repeat left center;
  }
  .x2 {
    margin-top:0.1rem;
    height: 18px;
    background: url(../../assets/mobile/bar8_a.png) no-repeat left center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/medicalRecord/index.vue